import React, { Suspense, useEffect, useState } from 'react';
import { UserManager, useUser } from '@forge/sso-client';
import { SetAppToken } from '../components/AppRoutes/SetAppToken';
import {LoaderInfo} from '../components/AppRoutes/LoaderInfo';
import EmptyDashboard from '../pages/dashboard/EmptyDashboard'; 
import PrivacyStatement from 'src/pages/LandingPage/PrivacyStatement';
import { useSelector, useDispatch } from 'react-redux';
import { getPrivacyNoticeStatus, getOnBoardingStatus, updatePrivacyNoticeStatus } from 'src/slices/onBoardingSlice';
import { Loader } from '@scuf/common';
import { toast } from 'react-toastify';
import { Snackbar } from 'src/components/Snackbar/Snackbar';


const PrivacyConsentWrapper = ({ children }) => {
  
  const dispatch = useDispatch();
  const isPrivacyNoticeAccepted = useSelector(getPrivacyNoticeStatus);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    
    const fetchPrivacyConsent = async () => {
      try {
        await dispatch(getOnBoardingStatus());
      } catch (error) {
        console.error('Error fetching privacy consent status:', error);
      } 
      finally {
        // setIsLoading(false);
      }
    };
    fetchPrivacyConsent();
  }, [dispatch]);

  const handlePrivacyAccept = async () => {
    try {
      setIsLoading(true);
      let obj = { userresponse : true }
      await dispatch(updatePrivacyNoticeStatus(obj)).then(async (response:any) => {
        if(response.meta.requestStatus === "fulfilled" && response.payload === true){
          console.log(response)
          await dispatch(getOnBoardingStatus()).then(async (response:any) => {
            if(response.meta.requestStatus === "fulfilled"){
              setIsLoading(false)
            }
          });
        }
        else{
          toast.error(
            <Snackbar toastMessage={'Something went wrong, please try again!'} />,
            {
              position: 'top-right',
              className: 'fi-toast--snackbar',
              bodyClassName: 'fi-toast__body--snackbar',
              closeOnClick: true,
            }
          );
        }
      })
    } catch (error) {
      console.error('Error updating privacy consent status:', error);
    }
  };

  if (isLoading) {
    return <Loader loading={true} text='Loading...' />;
  }
  if (isPrivacyNoticeAccepted === undefined) {
    return <>{children}</>;
  }

  if (isPrivacyNoticeAccepted === false) {
    console.log(isPrivacyNoticeAccepted)
    return <PrivacyStatement onAccept={handlePrivacyAccept} />;
  }

  if(isPrivacyNoticeAccepted === true) {
    return <>{children}</>;
  }
}

const PrivateRoute = (prop:any) => {
    const [user, isLoading] = useUser();
    useEffect(()=>{
      if(!user && !isLoading) {
        UserManager.getInstance().signinRedirect()
      }
    }, [isLoading, user])
    if(user) {
     return ( <SetAppToken user={user}>
              <PrivacyConsentWrapper>
                <Suspense fallback={<EmptyDashboard/>}>
                  {prop.children}
                </Suspense>
              </PrivacyConsentWrapper>
           </SetAppToken>
     );
    }
    return  <LoaderInfo />;
  }

  export default PrivateRoute;
  